// In-memory cache for /api/settings. Survives client-side navigation; cleared on hard refresh.
// One in-flight Promise per session; multiple SmsTemplateEditor instances share it.

let allSettingsPromise: Promise<Record<string, string>> | null = null;

export function loadAllSettings(): Promise<Record<string, string>> {
  if (!allSettingsPromise) {
    allSettingsPromise = fetch("/api/settings", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.statusText))))
      .catch((err) => {
        allSettingsPromise = null;
        throw err;
      });
  }
  return allSettingsPromise;
}

/** Invalidate the cache — call after a write. */
export function invalidateSettings(): void {
  allSettingsPromise = null;
}

/** Fire-and-forget warm-up. Safe to call eagerly. */
export function preloadSettings(): void {
  loadAllSettings().catch(() => {});
}
